//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
export default {
  name: 'OverviewPage',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {};
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.dataops.sub_title'),
        disabled: true
      }];
    },
    cards: function cards() {
      return [{
        title_es: 'Nueva orquestación',
        title_en: 'New orchestration',
        color: '#F1F1F1',
        image: 'Model.png',
        flex: 4,
        path: '/dataops/orchestration',
        access: true
      }, {
        title_es: 'Importar Script',
        title_en: 'Import Script',
        color: '#F1F1F1',
        image: 'UploadData.png',
        flex: 4,
        path: '/dataops/import_script',
        access: true
      }, {
        title_es: 'Historial de ejecuciones',
        title_en: 'Execution history',
        color: '#F1F1F1',
        image: 'UseCase.png',
        flex: 4,
        path: '/dataops/executions_history',
        access: true
      }];
    }
  }
};